<div class="wrapper">
    <div class="sidebar" data-color="white" data-background-color=""
        style="background-color: #fff;  box-shadow: 0 0 1.25rem rgba(31, 45, 61, .04);">
        <app-sidebar></app-sidebar>
        <div class="" style="background-color: #fff; box-shadow: 0 0 1.25rem rgba(31, 45, 61, .04);"></div>
    </div>
    <div class="main-panel">
        <app-navbar></app-navbar>
        <router-outlet></router-outlet>
        <app-footer></app-footer>
        <!-- <div *ngIf="!isMap()">
            <app-footer-cmp></app-footer-cmp>
        </div> -->
    </div>
    <!-- <app-fixedplugin></app-fixedplugin> -->
</div>